<template>
  <youtube
    class="pb-1 pt-2"
    :video-id="src"
    ref="youtube"
    @click="playVideo"
    width="100%"
    height="240">
  </youtube>
</template>

<script>
export default {
  data () {
    return {
      videoId: ''
    }
  },
  methods: {
    playVideo () {
      this.player.playVideo()
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    }
  },
  props: ['src']
}
</script>
